export default __webpack_public_path__ + "static/media/Product_04.6e8df012.webp";